import Nav from "../components/signal/Nav";
import Hero from "../components/signal/Hero";
import ContextStrip from "../components/signal/ContextStrip";
import Problem from "../components/signal/Problem";
import WhatItDoes from "../components/signal/WhatItDoes";
import UseCase from "../components/signal/UseCase";
import InsightShift from "../components/signal/InsightShift";
import Outcomes from "../components/signal/Outcomes";
import Value from "../components/signal/Value";
import HowItWorks from "../components/signal/HowItWorks";
import WhoFor from "../components/signal/WhoFor";
import Assessment from "../components/signal/Assessment";
import FinalCTA from "../components/signal/FinalCTA";
import Footer from "../components/signal/Footer";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Nav />
      <h1 className="sr-only">Signal AI by Gowitek — Know where AI will actually drive ROI</h1>
      <Hero />
      <ContextStrip />
      <Problem />
      <WhatItDoes />
      <UseCase />
      <InsightShift />
      <Outcomes />
      <Value />
      <HowItWorks />
      <WhoFor />
      <Assessment />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default Index;
